import { ISaveSkillViewPayload } from '../../../libs/utils/interfaces/skill-launch-interface';
import requestInstance from '../../utils/instance-utils';

export const saveSkillView = (
    payload: ISaveSkillViewPayload,
    isWhitelisted: boolean
) =>
    requestInstance.post('content/save-skill-view', payload, {
        headers: { 'X-Is-Whitelisted': String(isWhitelisted) },
    });
export const getCourseDetails = (courseId: number) =>
    requestInstance.get(`content/course?courseId=${courseId}`);
export const getCourseIdsByCourseIdentifiers = (payload: any) =>
    requestInstance.post('content/get-course-ids-by-courseIdentifiers', {
        courseIdentifiers: payload,
    });
